import { Navigate, Route, Routes } from "react-router";
import type { Me } from "@omnabase/shared";
import { AdminHome } from "./AdminHome";
import { AdminWorkspace } from "./AdminWorkspace";
import { AdminDataJobs, AdminUnrouted } from "./AdminLists";
import { AdminWorkspaces } from "./AdminWorkspaces";
import { AdminPlans } from "./AdminPlans";
import { AdminMore } from "./AdminMore";

/** /admin/*: for a platform administrator (`me.platformAdmin`, read per request); anyone else is sent to the app (a non-administrator
 *  sees no area at all, and the API answers 404 to every admin route anyway). Routed before /:workspace/* in App.tsx: admin is a
 *  reserved slug the workspace router must never see. */
export function AdminRoutes({ me }: { me: Me }) {
  if (!me.platformAdmin) return <Navigate to={me.workspaces[0] ? `/${me.workspaces[0].slug}` : "/signin"} replace />;
  return (
    <Routes>
      <Route index element={<AdminHome me={me} />} />
      <Route path="workspaces/:id" element={<AdminWorkspace me={me} />} />
      <Route path="workspaces" element={<AdminWorkspaces me={me} />} />
      <Route path="unrouted-mail" element={<AdminUnrouted me={me} />} />
      <Route path="data-jobs" element={<AdminDataJobs me={me} />} />
      <Route path="plans" element={<AdminPlans me={me} />} />
      <Route path="more" element={<AdminMore me={me} />} />
      <Route path="*" element={<Navigate to="/admin" replace />} />
    </Routes>
  );
}
